import React, { createContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import api from '../api'
// import { LoadingMessage } from 'components/common/LoadingMessage'

export const UserContext = createContext(null)

const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const userReducer = useSelector(state => state.userReducer.user)
  useEffect(() => {
    api
      .getAuthedUser()
      .then(user => {
        setUser(user)
      })
      .catch(() => {
        setUser(null)
      })
    return api.onAuthedUserStateChange(user => {
      setUser(user)
    })
  }, [userReducer])

  // if (typeof user === 'undefined') {
  //   return <LoadingMessage />
  // }
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>
}

export default UserContextProvider
